import React, { useEffect, useState } from 'react';
import LoadingPage from '../LoadingPage';
import Kanban from './Kanban';
import ApiService from '../../services/ApiService';
import PartCard from './PartCard';

const renderTemplate = item => {
  return <PartCard item={item} />;
};

const PartBoard = () => {
  const [loading, setLoading] = useState(true);
  const [columns, setColumns] = useState([]);
  const [columnItems, setColumnItems] = useState({});

  const getColumns = () => {
    setLoading(true);

    return ApiService.get('/part/requests').then(response => {
      const { statusList, requests } = response.data;

      const newColumns = [];
      const newColumnItems = {};

      // Setup Open/Unassigned swimlane
      newColumnItems[0] = [];
      newColumns.push({ name: 'Open' });

      statusList.forEach(status => {
        newColumns.push(status);
        newColumnItems[status.id] = [];
      });

      requests.forEach(request => {
        if (!request.key) {
          return;
        }

        if (!newColumnItems[request.status]) {
          newColumnItems[0].push({ id: request.key, ...request });
          return;
        }
        newColumnItems[request.status].push({ id: request.key, ...request });
      });

      setColumns(newColumns);
      setColumnItems(newColumnItems);
      setLoading(false);
    });
  };

  const handleChange = (source, dest, item, columns) => {
    const statusId = parseInt(dest.droppableId);
    const key = item.id;

    return ApiService.post('report/partrequeststatusupdate', { statusId, key });
  };

  useEffect(() => {
    getColumns();
  }, []);

  if (loading) {
    return <LoadingPage />;
  }

  const pools = {
    Parts: columns,
    // Trailers: columns,
  };

  return (
    <Kanban
      name="parts-request"
      pools={pools}
      setColumns={setColumns}
      setColumnItems={setColumnItems}
      columnItems={columnItems}
      renderTemplate={renderTemplate}
      onChange={handleChange}
    />
  );
};

export default PartBoard;
